import { Select as MuiSelect, SelectChangeEvent } from '@mui/material'
import { MenuItem, Select as VaporSelect } from '@vapor/material'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { GenderType } from 'src/api/api.generated'
import { displayGender, displayGenderShort, genderList } from 'src/utils/gender'
const Select = VaporSelect as unknown as typeof MuiSelect

export type GenderSelectProps = {
  value: GenderType | null
  onChange: (value: GenderType | null) => void
  disabled?: boolean
  error?: boolean
  size?: 'small' | 'medium'
}

export default function GenderSelect({ value, onChange, disabled, error, size }: GenderSelectProps) {
  const { t } = useTranslation()
  const selectOnChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      const v = genderList.find((g) => g === event.target.value) ?? null
      onChange(v)
    },
    [onChange],
  )
  return (
    <Select //
      size={size}
      value={value || ''}
      onChange={selectOnChange}
      renderValue={(value) => {
        const g = genderList.find((g) => g === value)
        return g ? displayGenderShort(t, g) : ''
      }}
      disabled={disabled}
      error={error}
    >
      {genderList.map((gender) => (
        <MenuItem key={gender} value={gender}>
          {displayGender(t, gender)}
        </MenuItem>
      ))}
      <MenuItem value={''}>-</MenuItem>
    </Select>
  )
}
